import { GET_REPORT_DEFINITIONS } from '../../actions/constants';

export default reportDefinitionName => ({
    type: GET_REPORT_DEFINITIONS,
    payload: reportDefinitionName,
});
